import { useCallback, useEffect } from 'react'

import { useDialog } from '@loadsmart/loadsmart-ui'
import { Dialog, Text } from '@loadsmart/miranda-react'

import { useAnalytics } from 'core/analytics/useAnalytics'

import { useTrackingOnboardingContext } from './TrackingOnboardingContext'

export default function UserNotOnboardedDialog() {
  const { track } = useAnalytics()

  const { showUserNotOnboardedDialog, viewNotOnboardedDialog, openTrackingConnectionDrawer } =
    useTrackingOnboardingContext()

  const notOnboardedDialog = useDialog({ open: showUserNotOnboardedDialog })

  const handleOnMaybeLater = useCallback(() => {
    notOnboardedDialog.hide()
    viewNotOnboardedDialog()
    track('Ignored: Tracking onboarding dialog')
  }, [notOnboardedDialog, track, viewNotOnboardedDialog])

  const handleSetup = useCallback(() => {
    notOnboardedDialog.hide()
    viewNotOnboardedDialog()
    openTrackingConnectionDrawer()
    track('Open setup: Tracking onboarding dialog')
  }, [notOnboardedDialog, openTrackingConnectionDrawer, track, viewNotOnboardedDialog])

  useEffect(() => {
    if (showUserNotOnboardedDialog) track('Viewed: Tracking onboarding dialog')
  }, [showUserNotOnboardedDialog, track])

  return (
    <Dialog open={notOnboardedDialog.open} size="medium">
      <Dialog.Header>
        <Text variant="heading-md-bold">Unlock all your tracking potential</Text>
        <Dialog.Close onClick={handleOnMaybeLater} />
      </Dialog.Header>
      <Dialog.Body>
        <Text variant="body-md">
          Select your preferred tracking method and streamline your process. No need to set tracking
          information for every new load—make it faster, simpler, and more efficient.
        </Text>
      </Dialog.Body>
      <Dialog.Actions>
        <Dialog.ActionTertiary onClick={handleOnMaybeLater}>Maybe later</Dialog.ActionTertiary>
        <Dialog.ActionPrimary onClick={handleSetup}>Setup it now</Dialog.ActionPrimary>
      </Dialog.Actions>
    </Dialog>
  )
}
